export default "__VITE_ASSET__BHANWaPF__"